<script lang="ts">
    import { getCachedEntries } from "../../../api"
    import { spaLink } from "../../actions"
    import Icon from "../Icon.svelte"
    import MedialibImage from "../MedialibImage.svelte"
    import Cta from "./widgets/CTA.svelte"
    import MiniLoader from "./widgets/MiniLoader.svelte"

    export let block: ContentBlock<"teamPreview">
    const teamP = block.teamMemberPreview
    const memberIds = teamP.map((member) => member.teamMember)
    const getTeamEntries = async () => {
        const team = await getCachedEntries<"team">("team", {
            _id: { $in: memberIds },
        })
        return memberIds.map((id) => team.find((member) => member.id === id))
    }
    const chevronRight =
        "M35.4453 32L23.1786 19.7333L25.0666 17.8453L39.2213 32L25.0666 46.1547L23.1786 44.2667L35.4453 32Z"
</script>

{#await getTeamEntries()}
    <MiniLoader />
{:then team}
    <ul class="cardWrapper row">
        {#each team as member, i}
            {#if member}
                <li>
                    <div class="image"><MedialibImage id="{member.previewimage}" /></div>
                    <div class="content">
                        <a class="upper" use:spaLink href="{teamP[i].teamMemberPagePath}#{member.id}">
                            <span> <Icon path="{chevronRight}" color="#59676F" size="64px" viewBox="0 0 64 64" /></span>
                            <div>
                                <h3>
                                    {#each member.titles as title}
                                        {title} &nbsp;
                                    {/each}
                                    {member.name}
                                </h3>
                                <ul>
                                    {#each member.specialties as specialty}
                                        <li>{specialty}</li>
                                    {/each}
                                </ul>
                            </div>
                        </a>
                        <div class="lower">
                            <p>{@html teamP[i].shortDescription}</p>
                            <Cta path="{teamP[i].teamMemberPagePath}#{member.id}">zur Vita</Cta>
                        </div>
                    </div>
                </li>
            {/if}
        {/each}
    </ul>
{/await}

<style lang="less">
    @import "../../../css/variables.less";
    ul.cardWrapper {
        justify-content: space-between;
        display: flex;
        gap: var(--default-gap);
        @media @max-tablet {
            flex-direction: column;
        }

        & > li {
            display: flex;
            flex-direction: column;
            position: relative;
            width: 100%;
            flex-grow: 1;

            .image {
                right: 64px;
                left: 0px;
                width: calc(100% - 64px);
                position: relative;
                @media @mobile {
                    right: 0px;
                    width: 100%;
                }
            }
            .content {
                left: 112px;
                flex-grow: 1;
                width: calc(100% - 112px);
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                z-index: 100;
                box-shadow: 0px 0px 48px 0px rgba(89, 103, 111, 0.24);
                margin-top: -64px;
                border-radius: 24px 6px 6px 6px;
                background: rgba(255, 255, 255, 0.9);
                padding-bottom: 24px;
                gap: var(--default-gap);
                @media @mobile {
                    left: 0px;
                    width: 100%;
                }
                .upper {
                    display: flex;
                    max-width: 360px;
                    margin: 0px 30px;
                    width: 100%;
                    position: relative;
                    &:hover {
                        span {
                            transform: translateX(6px);
                        }
                    }
                    span {
                        padding-top: 6px;
                        padding-bottom: 6px;
                        position: absolute;
                        width: 76px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        left: -70px;
                        transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
                        @media @mobile {
                            left: -15px;
                            position: relative;
                        }
                    }
                    div {
                        display: flex;
                        flex-direction: column;
                        gap: 18px;
                        padding-top: 28px;
                    }
                }
                .lower {
                    max-width: 360px;
                    margin: 0px 30px;
                    display: flex;
                    flex-direction: column;
                    gap: var(--default-gap);
                    justify-content: space-between;
                    flex-grow: 1;
                }
            }
        }
    }
</style>
